import { useMutation } from '@tanstack/react-query'

import { getSaltoSpaceAccessPointsQueryKey } from '@/api/keyless/salto-space/get-salto-space-access-points'
import { integrationAPI } from '@/api/new-api'
import { resetQueries } from '@/utils'

import {
  getSaltoSpaceConnectionQueryKey,
  SaltoSpaceLevelRef,
  SaltoSpaceZoneRef,
} from './get-salto-space-connection'

type UpdateSaltoSpaceConnectionRequest = {
  buildingId: number
  apiKey: string
  url: string
  config: {
    shouldAutoAssignApartmentDoor: boolean
    shouldAutoAssignUserAccessLevel: boolean
    permissionGroups: SaltoSpaceZoneRef[]
    accessLevels: SaltoSpaceLevelRef[]
    visitorPermissionGroups: SaltoSpaceZoneRef[]
    visitorAccessLevels: SaltoSpaceLevelRef[]
  }
}

const updateSaltoSpaceConnection = async (data: UpdateSaltoSpaceConnectionRequest) => {
  const response = await integrationAPI.post('/salto-space/integration', data)
  return response.data
}

export const useUpdateSaltoSpaceConnection = () =>
  useMutation({
    mutationFn: updateSaltoSpaceConnection,
    onSuccess: async (_data, variables) => {
      const buildingId = { buildingId: variables.buildingId }
      await resetQueries(
        [getSaltoSpaceConnectionQueryKey(buildingId)],
        [getSaltoSpaceAccessPointsQueryKey(buildingId)],
      )
    },
  })
